// Canonical English copy for the assistant identity fields (icon/name),
// shared between the hub's Editor Mode "General" tab (branding-level
// override, in apps/hub) and the admin CMS's Assistant "General" tab
// (room-level fallback, in apps/admin). The two tabs edit different records
// in a fallback chain, but the wording should read identically to the user.
//
// Hub also mirrors this text into `apps/hub/src/locales/common/en/index.json`
// — i18next needs a static catalog and cannot read a JS import — so that file
// must be kept in sync with these constants by hand. This module is the
// single source of truth for the English strings; admin imports them
// directly since it has no i18n layer of its own.
export const ASSISTANT_GENERAL_TAB_INTRO =
  "How the assistant looks and what it's called.";
export const ASSISTANT_ICON_UPLOAD_LABEL = 'Upload image';
// Names the action (clearing the stored value), not its outcome: in the hub
// that outcome is the room's icon when it has one, not necessarily "the
// default" — see ASSISTANT_ICON_HINT for what happens once this is clicked.
export const ASSISTANT_ICON_RESET_LABEL = 'Delete icon';
export const ASSISTANT_ICON_HINT =
  'Leave empty to use the default icon. Square images work best.';
export const ASSISTANT_NAME_HINT =
  'Shown in the chat and on the assistant button. Leave empty to use the default name.';
